<template>
    <div>

        <p v-html="lang.polaris.training.delete_registration_confirm"></p>

        <!-- Field -->

        <trax-ui-input type="text" class="mb-3" v-model="input">
        </trax-ui-input>

        <!-- Button -->

        <div class="mb-3 mt-3 pl-1 pr-1">
            <trax-ui-ajax-button :label="lang.polaris.form.confirm" :endpoint="endpoint" :id="id" :bus="bus"
                color="default" v-show="input==='DELETE'" method="delete">
            </trax-ui-ajax-button>
        </div>

    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                lang: lang,
                input: '',
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id+'/force',
                id: 'trax-training-registration-force-delete',
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-success', this.success);
        },
        
        methods: {

            success() {
                window.location = '../crud';
            }
        }

    }
</script>
